// import React, {useState, useEffect} from "react";
// import { Link } from "react-router-dom";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination } from "swiper/modules";
// import { motion } from "framer-motion";
// import { FaSearch, FaMobileAlt } from "react-icons/fa";
// import { useTranslation } from "react-i18next";
// import axios from "axios";

// import "swiper/css";
// import "swiper/css/pagination";

// /* -------- IMAGES -------- */
// import slider1 from "../../images/small_poster1.jpg";
// import slider2 from "../../images/small_poster2.jpg";
// import slider3 from "../../images/small_poster3.jpg";

// import bannerAdd1 from "../../images/small_poster4.jpg";
// import bannerAdd2 from "../../images/small_poster5.jpg";

// const slides = [
//   {
//     image: slider1,
//     badgeKey: "fresh_deals",
//     titleKey: "fresh_essentials_delivered",
//     descKey: "shop_vegetables_fruits",
//   },
//   {
//     image: slider2,
//     badgeKey: "digital_ordering",
//     titleKey: "order_smarter_mahal_app",
//     descKey: "browse_compare_suppliers",
//   },
//   {
//     image: slider3,
//     badgeKey: "fast_delivery",
//     titleKey: "fast_reliable_bulk_deliveries",
//     descKey: "warehouse_to_kitchen",
//   },
// ];

// // const slides = [
// //   {
// //     image: slider1,
// //     badge: "Fresh Deals",
// //     title: "Fresh Essentials Delivered to Your Doorstep",
// //     desc: "Shop vegetables, fruits & daily groceries at unbeatable prices.",
// //   },
// //   {
// //     image: slider2,
// //     badge: "Digital Ordering",
// //     title: "Order Smarter with the Mahal Mobile App",
// //     desc: "Browse, compare suppliers & manage bulk orders in one place.",
// //   },
// //   {
// //     image: slider3,
// //     badge: "Fast Delivery",
// //     title: "Fast & Reliable Bulk Deliveries",
// //     desc: "From warehouse to kitchen — on time, every time.",
// //   },
// // ];

// const BannerSection = () => {
  
//   const [promotions, setPromotions] = useState([]);

//   useEffect(() => {
//     axios
//       .get("https://api.mahal.qa/api/v1/promotions")
//       .then((res) => {
//         setPromotions(res.data);
//       });
//   }, []);

//   const { t, i18n } = useTranslation();
//   const isArabic = i18n.language === "ar";

//   return (
//     <section className="mm-hero-section mt-4 container px-4">
//       <div className="row g-4" dir="ltr">

//         {/* ================= LEFT HERO ================= */}
//         <div className="col-xl-8">
//           <Swiper
//             modules={[Autoplay, Pagination]}
//             autoplay={{ delay: 4000 }}
//             pagination={{ clickable: true }}
//             loop
//             slidesPerView={1}
//             className="mm-hero-swiper"
//           >
//             {/* {slides.map((slide, index) => ( */}
//             {promotions.map((promo, index) => (
//               <SwiperSlide key={index}>
//                 <div
//                   className="mm-hero-slide"
//                   // style={{ backgroundImage: `url(${slide.image})` }}
//                   style={{ backgroundImage: `url(${promo.image_url})` }}
//                 >
//                   <div className="mm-hero-overlay"></div>

//                   <div className="mm-hero-content" dir={isArabic ? "rtl" : "ltr"}>

//                     <motion.span
//                       className="mm-hero-badge"
//                       initial={{ opacity: 0, y: -10 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.6 }}
//                     >
//                       {/* {t(slide.badgeKey)} */}
//                       {promo.title}
//                     </motion.span>

//                     <motion.h1
//                       // key={t(slide.titleKey)}
//                       key = {promo.headline}
//                       initial={{ opacity: 0, y: 30 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.8 }}
//                     >
//                       {/* {t(slide.titleKey)} */}
//                       {promo.headline}
//                     </motion.h1>

//                     <motion.p
//                       // key={t(slide.descKey)}
//                       key = {promo.description}
//                       initial={{ opacity: 0 }}
//                       animate={{ opacity: 1 }}
//                       transition={{ delay: 0.4 }}
//                     >
//                       {/* {t(slide.descKey)} */}
//                       {promo.description}
//                     </motion.p>

//                     {/* SEARCH BAR */}
//                     <div className="mm-hero-search">
//                       <FaSearch />
//                       <input
//                         type="text"
//                         placeholder={t("search_products_suppliers")}
//                       />
//                       <button>{t("search")}</button>
//                     </div>

//                     {/* CTA BUTTONS */}
//                     <div className="mm-hero-cta">
//                       {/* <Link to="/ShopDetails" className="mm-hero-btn">
//                         {t("explore_now")} →
//                       </Link> */}

//                       <Link
//                         to={`/offer-products?promotion=${promo.id}`}
//                         className="mm-hero-btn"
//                       >
//                         {t("explore_now")} →
//                       </Link>

//                       <Link to="#" className="mm-download-btn">
//                         <FaMobileAlt /> {t("download_app")}
//                       </Link>
//                     </div>

//                   </div>
//                 </div>
//               </SwiperSlide>
//             ))}
//           </Swiper>
//         </div>

//         {/* ================= RIGHT SIDE BANNERS ================= */}
//         <div className="col-xl-4">
//           <div
//             className="mm-side-banner"
//             style={{ backgroundImage: `url(${bannerAdd1})` }}
//           >
//             <div className="mm-side-overlay"></div>
//             <div className="mm-side-content" dir={isArabic ? "rtl" : "ltr"}>
//               <h4>{t("summer_offer")}</h4>
//               <h3>{t("healthy_organic_food")}</h3>
//               {/* <Link to="/ShopDetails">{t("shop_now")} →</Link> */}
//               <Link to="/offer-products?keyword=summer">
//                 {t("shop_now")} →
//               </Link>
//             </div>
//           </div>

//           <div
//             className="mm-side-banner"
//             style={{ backgroundImage: `url(${bannerAdd2})` }}
//           >
//             <div className="mm-side-overlay"></div>
//             <div className="mm-side-content" dir={isArabic ? "rtl" : "ltr"}>
//               <h4>{t("special_offer")}</h4>
//               <h3>{t("fresh_organic_food")}</h3>
//               {/* <Link to="/ShopDetails">{t("shop_now")} →</Link> */}
//               <Link to="/offer-products?keyword=special">
//                 {t("shop_now")} →
//               </Link>
//             </div>
//           </div>
//         </div>

//       </div>
//     </section>
//   );
// };

// export default BannerSection;





import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { motion } from "framer-motion";
import { FaSearch, FaMobileAlt } from "react-icons/fa";
import axios from "axios";

import "swiper/css";
import "swiper/css/pagination";

/* -------- IMAGES -------- */
import slider1 from "../../images/small_poster1.jpg";
import slider2 from "../../images/small_poster2.jpg";
import slider3 from "../../images/small_poster3.jpg";

import bannerAdd1 from "../../images/small_poster4.jpg";
import bannerAdd2 from "../../images/small_poster5.jpg";

const slides = [
  {
    image: slider1,
    badge: "Fresh Deals",
    title: "Fresh Essentials Delivered to Your Doorstep",
    desc: "Shop vegetables, fruits & daily groceries at unbeatable prices.",
  },
  {
    image: slider2,
    badge: "Digital Ordering",
    title: "Order Smarter with the Mahal Mobile App",
    desc: "Browse, compare suppliers & manage bulk orders in one place.",
  },
  {
    image: slider3,
    badge: "Fast Delivery",
    title: "Fast & Reliable Bulk Deliveries",
    desc: "From warehouse to kitchen — on time, every time.",
  },
];

const BannerSection = () => {

  const [promotions, setPromotions] = useState([]);

  useEffect(() => {
    axios
      .get("https://api.mahal.qa/api/v1/promotions")
      .then((res) => {
        setPromotions(res.data);
      });
  }, []);

  return (
    <section className="mm-hero-section mt-4 container  px-4">
      <div className="row g-4">

        {/* ================= LEFT HERO ================= */}
        <div className="col-xl-8">
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 4000 }}
            pagination={{ clickable: true }}
            loop
            slidesPerView={1}
            className="mm-hero-swiper"
          >
            {/* {slides.map((slide, index) => ( */}
            {promotions.map((promo, index) => (
              <SwiperSlide key={index}>
                <div
                  className="mm-hero-slide"
                  // style={{ backgroundImage: `url(${slide.image})` }}
                  style={{ backgroundImage: `url(${promo.image_url})` }}
                >
                  <div className="mm-hero-overlay"></div>

                  <div className="mm-hero-content">

                    <motion.span
                      className="mm-hero-badge"
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6 }}
                    >
                      {/* {slide.badge} */}
                      {promo.title}
                    </motion.span>

                    <motion.h1
                      // key={slide.title}
                      key = {promo.headline}
                      initial={{ opacity: 0, y: 30 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.8 }}
                    >
                      {/* {slide.title} */}
                      {promo.headline}
                    </motion.h1>

                    <motion.p
                      // key={slide.desc}
                      key = {promo.description}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 0.4 }}
                    >
                      {/* {slide.desc} */}
                      {promo.description}
                    </motion.p>

                    {/* SEARCH BAR */}
                    <div className="mm-hero-search">
                      <FaSearch />
                      <input
                        type="text"
                        placeholder="Search products, suppliers..."
                      />
                      <button>Search</button>
                    </div>

                    {/* CTA BUTTONS */}
                    <div className="mm-hero-cta">

                      {/* <Link
                        to={`/supplier-promotions/${promo.id}`}
                        className="mm-hero-btn"
                      >
                        Explore Now →
                      </Link> */}

                      <Link
                        to={`/offer-products?promotion=${promo.id}`}
                        className="mm-hero-btn"
                      >
                        Explore Now →
                      </Link>

                      <Link to="#" className="mm-download-btn">
                        <FaMobileAlt /> Download App
                      </Link>
                    </div>

                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* ================= RIGHT SIDE BANNERS ================= */}
        <div className="col-xl-4">
          <div
            className="mm-side-banner"
            style={{ backgroundImage: `url(${bannerAdd1})` }}
          >
            <div className="mm-side-overlay"></div>
            <div className="mm-side-content">
              <h4>Summer Offer</h4>
              <h3>Healthy Organic Food</h3>
              {/* <Link to="/ShopDetails">Shop Now →</Link> */}
              <Link to="/offer-products?keyword=summer">
                Shop Now →
              </Link>
            </div>
          </div>

          <div
            className="mm-side-banner"
            style={{ backgroundImage: `url(${bannerAdd2})` }}
          >
            <div className="mm-side-overlay"></div>
            <div className="mm-side-content">
              <h4>Special Offer</h4>
              <h3>Fresh Organic Food</h3>
              {/* <Link to="/ShopDetails">Shop Now →</Link> */}
              <Link to="/offer-products?keyword=special">
                Shop Now →
              </Link>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default BannerSection;